import React, { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { BugReportRounded } from "@mui/icons-material";
import { useUser } from "../../hooks/useUser";
import { INTERNAL_ROLE_KEYS, SystemRoleKey } from "../../providers/roles";
import { BugReportModal } from "./BugReportModal";

// Internal-only "report a bug" entry point (the API rejects other roles
// regardless — hiding it here is UX, not security).
export function BugReportButton() {
  const { role } = useUser();
  const [open, setOpen] = useState(false);

  if (!INTERNAL_ROLE_KEYS.includes(String(role) as SystemRoleKey)) return null;

  return (
    <>
      <Tooltip title="Report a bug">
        <IconButton aria-label="Report a bug" color="primary" onClick={() => setOpen(true)}>
          <BugReportRounded />
        </IconButton>
      </Tooltip>
      {open && <BugReportModal open={open} onClose={() => setOpen(false)} />}
    </>
  );
}
